module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['ep-radio-list', {
      'active': _vm.active
    }],
    on: {
      "click": _vm.seleted
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d96cde8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iexplore/components/radio/src/radio_list.vue
// module id = 1244
// module chunks = 2